import { CSSProperties, ReactNode } from 'react';
import { ToggleButton } from 'react-aria-components';

import IconToggle from '@/icons/Toggle.svg';
import { createBEMClasses } from '@/utils/classname';

import './Toggle.css';

export type ToggleProps = {
  isSelected?: boolean;
  onChange?: (isSelected: boolean) => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
  label?: ReactNode;
  ariaLabel?: string;
  size?: 'small' | 'large';
  variant?: 'default' | 'brand';
  alignment?: 'left' | 'right';

  className?: string;
  style?: CSSProperties;
};

const { block } = createBEMClasses('toggle');

const Toggle = ({
  isSelected = false,
  onChange,
  isDisabled,
  isInvalid,
  label,
  ariaLabel,
  size = 'large',
  variant = 'default',
  alignment = 'right',
  className,
  style,
}: ToggleProps) => {
  return (
    <div
      className={block(
        {
          size,
          variant,
          alignment,
          selected: isSelected,
          disabled: isDisabled,
          invalid: isInvalid,
        },
        className
      )}
      style={style}
    >
      <ToggleButton
        aria-label={ariaLabel ?? (typeof label === 'string' ? label : undefined)}
        isSelected={isSelected}
        isDisabled={isDisabled}
        onChange={onChange}
      >
        <IconToggle on={isSelected} />
        {label && <label>{label}</label>}
      </ToggleButton>
    </div>
  );
};

export default Toggle;
